module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app__body",
    class: _vm.$route.name,
    attrs: {
      "id": "app"
    }
  }, [(this.$route.name !== 'view-video') ? _c('app-header') : _vm._e(), _vm._v(" "), _c('keep-alive', {
    attrs: {
      "include": 'register'
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 221
// module chunks = 1